<!-- @format -->

<license>
  <style>
    .visible {
      display: block;
    }
    ul.checkbox_list {
      display: flex;
      flex-wrap: wrap;
    }
    textarea[disabled] {
      opacity: 0.3;
      cursor: default;
    }
  </style>

  <div class="box_flex03 margin-spacing-4_bottom">
    <p class="heading-04">資格を検索する</p>
    <div class="box_w50 margin-spacing-2_left margin-spacing-2_right">
      <input
        class="text_input"
        type="text"
        name="searchWord"
        autocomplete="off"
        placeholder="資格を入力"
      />
    </div>
    <div
      class="button button-secondary js-modal-open"
      type="button"
      value="検索"
      onclick="{ onSearchLicense }"
    >
      検索
    </div>
  </div>

  <div class="container_accordion" each="{ category in state.master.license }">
    <div class="accordion_heading is-hide" data-group="{ category.id }">
      <div class="checkbox_wrap">
        <input
          type="checkbox"
          id="category_id_{ category.id }"
          class="checkbox-input"
          value="{ category.id }"
          onclick="{ onCheckCategory }"
        />
        <label for="category_id_{ category.id }" class="checkbox-parts">
          { category.jname }
        </label>
      </div>
      <div class="js-accordion"></div>
    </div>
    <!--/.accordion_heading-->

    <div
      class="accordion_body"
      data-group="{ category.id }"
      style="display: none"
    >
      <ul
        each="{ (license, index) in category.list }"
        class="checkbox_list { index ? 'margin-spacing-2_top' : '' }"
      >
        <li class="checkbox_list-item02">
          <input
            type="checkbox"
            name="license_id_{ license.license_id }"
            value="{ license.license_id }"
            checked="{ state.data.license.isChecked(license.license_id) }"
            id="license_id_{ license.license_id }"
            class="checkbox-input js-check_license-rank"
            onclick="{ onCheckLicense }"
          />
          <label for="license_id_{ license.license_id }" class="checkbox-parts">
            { license.jname }
          </label>
        </li>

        <li if="{ license.type=='select' }" class="checkbox_list-item03">
          <div class="sort-menu">
            <select
              class="sort-list select_license-rank"
              name="license_select_{license.license_id}"
              value="{ state.data.license.getRankId(license.license_id) }"
              disabled="{ !state.data.license.isChecked(license.license_id) }"
              onchange="{ e => onSelect(e, license.license_id)}"
            >
              <option
                each="{ rank in state.master.license_rank[license.license_id] }"
                value="{ rank.id }"
              >
                { rank.jname }
              </option>
            </select>
          </div>
          <!--/.sort-menu-->
        </li>

        <li if="{ license.type=='score' }" class="checkbox_list-item03">
          <div class="sort-menu">
            <input
              class="text_input"
              type="text"
              name="searchWord"
              value="{ state.data.license.getMemo(license.license_id) }"
              disabled="{ !state.data.license.isChecked(license.license_id) }"
              oninput="{ e => onText(e, license.license_id)}"
            />
          </div>
          <div class="sort-menu">
            <p class="margin-spacing-2_left">点</p>
          </div>
          <!--/.sort-menu-->
        </li>

        <li>
          <p
            class="alert_message note margin-spacing-2_left visible"
            if="{ state.licenseErrors[license.license_id] }"
          >
            { state.licenseErrors[license.license_id] }
          </p>
        </li>
      </ul>
    </div>
    <!--/.accordion_body-->
  </div>
  <!--/.container_accordion-->

  <template each="{ id in [state.data.license.otherId] }">
    <div class="accordion_heading02 margin-spacing-4_top">
      <div class="checkbox_wrap">
        <input
          type="checkbox"
          name="license_id_{ id }"
          value="{ id }"
          checked="{ state.data.license.isChecked(id) }"
          id="license_id_{ id }"
          class="checkbox-input js-check_license-rank"
          onclick="{ onCheckLicense }"
        />
        <label for="license_id_{ id }" class="checkbox-parts">その他</label>
      </div>
    </div>
    <textarea
      class="textarea_input"
      disabled="{ !state.data.license.isChecked(id) }"
      value="{ state.data.license.getMemo(id) }"
      oninput="{ e => onText(e, id) }"
    ></textarea>
    <div if="{ state.licenseErrors[id] }" class="error">
      { state.licenseErrors[id] }
    </div>
  </template>

  <h3 class="heading-03 margin-spacing-5_top">扱える言語・資格</h3>
  <ul class="checkbox_list margin-spacing-3_top">
    <li
      class="checkbox_list-item"
      each="{ language in state.master.language }"
      if="{ language.name!='other' }"
    >
      <input
        class="checkbox-input"
        type="checkbox"
        id="language_{ language.id }"
        value="{ language.id }"
        checked="{ state.data.language[language.id] }"
        onclick="{ onLanguageCheck }"
      />
      <label for="language_{language.id}" class="checkbox-parts">
        { language.jname }
      </label>
    </li>
  </ul>
  <template
    each="{ language in state.master.language }"
    if="{ language.name=='other' }"
  >
    <ul class="checkbox_list margin-spacing-1_top">
      <li class="checkbox_list-item">
        <input
          class="checkbox-input js-other_check"
          type="checkbox"
          id="language_{ language.id }"
          value="{ language.id }"
          checked="{ state.data.language[language.id] }"
          onclick="{ onLanguageCheck }"
        />
        <label for="language_{language.id}" class="checkbox-parts">
          { language.jname }
        </label>
      </li>
    </ul>
    <div class="box_w50">
      <input
        class="text_input other_check"
        type="text"
        name="language_memo_other"
        id="language_memo_other"
        value="{ state.data.languageMemoOther }"
        disabled="{ !state.data.language[language.id] }"
        oninput="{ onLanguageText }"
      />
    </div>
    <p
      class="alert_message note margin-spacing-2_left visible"
      if="{ state.languageErrors[language.id] }"
    >
      { state.languageErrors[language.id] }
    </p>
  </template>

  <div class="box_flex03 margin-spacing-2_top">
    <div
      class="button button-secondary-large"
      type="button"
      value="登録する"
      onclick="{ onSubmit }"
    >
      登録する
    </div>
  </div>

  <search-modal
    id="industries-modal"
    is-open="{ state.searchModalIsOpen }"
    on-close="{ e => update({searchModalIsOpen: false}) }"
    data="{ state.data.license }"
    groups="{ state.groups }"
    on-check="{ onCheckLicense }"
    on-select="{ onSelect }"
    on-text="{ onText }"
    on-submit="{ onSubmit }"
    errors="{ state.licenseErrors }"
    caption="資格"
  ></search-modal>

  <script>
    import di from "dependeny-injection";
    import PublicInfoApi from "@model/skillsheet/public-info-api.js";
    import modal from "@tags/modal/search-modal.riot";
    import { Licenses, LicenseMaster } from "@model/skillsheet/license.js";

    export default {
      components: {
        "search-modal": modal,
      },
      state: {
        searchModalIsOpen: false,
        searchWord: "",
        groups: [],
        master: {
          license: [],
          license_rank: [],
          language: [],
        },
        data: {
          license: new Licenses([]),
          language: {},
          languageMemoOther: "",
        },
        languageErrors: {},
        licenseErrors: {},
        isRegistered: false,
      },
      onBeforeMount() {
        this.PublicInfoApi = new PublicInfoApi();
      },
      async onMounted(state, props) {
        window.$(this.$('[name="searchWord"]')).autocomplete({
          source: (request, response) => {
            const { groups, list } = LicenseMaster.search(
              this.state.master.license,
              this.state.master.license_rank,
              request.term
            );
            this.update({ groups });
            response(list);
          },
        });
        const res = await this.PublicInfoApi.request("license", "fetch");
        this.update({
          master: res.master,
          data: {
            license: new Licenses(res.data.license),
            language: res.data.language.reduce((a, c) => {
              a[c.language_master_id] = true;
              return a;
            }, {}),
            languageMemoOther: res.data.language.reduce((a, c) => {
              if (c.language_master_id == 9) {
                a = c.memo;
              }
              return a;
            }, ""),
          },
        });
        this.update({ isRegistered: this.hasData(this.state) });
        for (const category of this.state.master.license) {
          for (const license of category.list) {
            if (license.type == "select") {
              this.$(
                `select[name="license_select_${license.license_id}"]`
              ).value = this.state.data.license.getRankId(license.license_id);
            }
          }
        }
        for (const id of this.state.data.license.getCheckedGroup(
          this.state.master.license
        )) {
          this.$(`[data-group="${id}"].accordion_heading`).classList.remove(
            "is-hide"
          );
          this.$(`[data-group="${id}"].accordion_body`).style.display = "block";
        }
      },
      hasData(state) {
        return (
          state.data.license.hasChecked() ||
          !!Object.values(state.data.language).find((e) => e)
        );
      },
      onCheckCategory(e) {
        for (const category of this.state.master.license) {
          if (category.id == e.target.value) {
            for (const license of category.list) {
              const select = this.$(
                `select[name="license_select_${license.license_id}"]`
              );
              this.state.data.license.update({
                id: license.license_id,
                rank_id: select ? select.value : undefined,
                checked: e.target.checked,
              });
            }
            break;
          }
        }
        this.update({ data: this.state.data });
      },
      onCheckLicense(e) {
        const select = this.$(
          `select[name="license_select_${e.target.value}"]`
        );
        this.state.data.license.update({
          id: e.target.value,
          rank_id: select ? select.value : undefined,
          checked: e.target.checked,
        });
        this.update({ data: this.state.data });
      },
      onSelect(e, licenseId) {
        this.state.data.license.update({
          id: licenseId,
          rank_id: e.target.value,
        });
        this.update({ data: this.state.data });
      },
      onText(e, licenseId) {
        this.state.data.license.update({
          id: licenseId,
          memo: e.target.value,
        });
        this.update({ data: this.state.data });
      },
      onSearchLicense() {
        const searchWord = this.$('[name="searchWord"]').value;
        if (searchWord === "") {
          di.toast.push("検索内容が入力されていません", "negative");
          return;
        }
        const { groups } = LicenseMaster.search(
          this.state.master.license,
          this.state.master.license_rank,
          searchWord
        );
        this.update({ searchWord, groups, searchModalIsOpen: true });
      },
      onLanguageCheck(e) {
        this.state.data.language[e.target.value] = e.target.checked;
        this.update({ data: this.state.data });
      },
      onLanguageText(e) {
        this.state.data.languageMemoOther = e.target.value;
        this.update({ data: this.state.data });
      },
      valid() {
        const licenses = this.state.data.license.getPostData(
            this.state.master.license
          ),
          license_err = {};

        for (let [k, v] of Object.entries(licenses.license_item_memos)) {
          if (!v) {
            const i = k.replace("license_item_memo_", "");
            license_err[i] = "入力してください";
          }
        }
        for (let [k, v] of Object.entries(licenses.license_item_ranks)) {
          if (!v) {
            const i = k.replace("license_item_rank_", "");
            license_err[i] = "選択してください";
          }
        }

        if (!Object.keys(license_err).length) {
          return true;
        }
        const error_obj = {
          message: "failed",
          success: false,
          data: {
            text: "入力に問題があります",
            errors: {
              license: {},
              language: {},
            },
          },
        };
        error_obj.data.errors.license = license_err;
        this.error(error_obj);
        return false;
      },
      async onSubmit() {
        this.update({ languageErrors: {}, licenseErrors: {} });
        if (!this.valid()) {
          return;
        }
        try {
          const res = await this.PublicInfoApi.request("license", "register", {
            ...this.state.data.license.getPostData(this.state.master.license),
            languages: Object.entries(this.state.data.language).reduce(
              (a, [id, flag]) => {
                if (flag) {
                  a.push(id);
                }
                return a;
              },
              []
            ),
            language_memo_other: this.state.data.language[9]
              ? this.state.data.languageMemoOther
              : "",
          });
          di.toast.push("職務経歴を更新しました", "success");
          // 新規登録イベント
          if (!this.state.isRegistered && this.hasData(this.state)) {
            this.update({ isRegistered: true });
            window.analytics.event("unlock_achievement", {
              achievement_id: "license_first_registration",
            });
          }
          this.update({ searchModalIsOpen: false });
        } catch (e) {
          this.error(e);
        }
      },
      error(e) {
        if (e.message == "failed") {
          di.toast.push(e.data.text, "negative");
          this.update({
            languageErrors: e.data.errors.language,
            licenseErrors: e.data.errors.license,
          });

          const container = window.document.querySelector(
            ".container_contents"
          );
          const error = this.$("p.alert_message").parentNode;
          const id = error
            .closest(`.accordion_body`)
            .getAttribute("data-group");
          this.$(`[data-group="${id}"].accordion_heading`).classList.remove(
            "is-hide"
          );
          this.$(`[data-group="${id}"].accordion_body`).style.display = "block";

          const top = error.getBoundingClientRect().y + container.scrollTop;
          container.scrollTo({ top: top - 8, behavior: "smooth" });
        } else {
          di.toast.push(e, "negative");
        }
      },
    };
  </script>
</license>
